import { z } from 'zod';

import { zod } from '@ui-furniture/lib/utils/zod-validation';

import {
  preferenceOptions,
  purchaseOptions,
  sellerOptions,
} from './quote-options';

const PreferenceSchema = z.object({
  urgency: zod.selectFromList(preferenceOptions.urgency).optional(),
  priority: zod.selectFromList(preferenceOptions.priority).optional(),
});

export const PurchaseSchema = z
  .object({
    purchaseDetails: z.object({
      price: zod.currency({
        invalid_type_error: 'An estimated price is required',
        validation: (schema) =>
          schema.min(10000, 'The purchase price must be at least £10,000'),
      }),
      mortgage: z.boolean(),
      buyerCount: z.coerce
        .number()
        .min(1, 'You need at least one buyer')
        .max(5, 'You can’t have that many buyers'),
      tenure: zod.selectFromList(purchaseOptions.tenure),
      areaOutcode: zod.outcode(),
      additionalDetails: z
        .array(zod.selectFromNestedList(purchaseOptions.additionalDetails))
        .optional(),
    }),
  })
  .merge(PreferenceSchema);

export const SaleSchema = z
  .object({
    saleDetails: z.object({
      price: zod.currency({
        invalid_type_error: 'An estimated price is required',
        validation: (schema) =>
          schema.min(10000, 'The sale price must be at least £10,000'),
      }),
      mortgage: z.boolean(),
      sellerCount: z.coerce
        .number()
        .min(1, 'You need at least one seller')
        .max(5, 'You can’t have that many sellers'),
      address: zod.oneLineAddress(),
      additionalDetails: z
        .array(zod.selectFromNestedList(sellerOptions.additionalDetails))
        .optional(),
    }),
  })
  .merge(PreferenceSchema);
